export const isCustomHost = () => {
  try {
    const h = window.location.hostname;
    const ph = new URL(process.env.REACT_APP_BACKEND_URL).hostname;
    return h !== ph && h !== "localhost" && h !== "127.0.0.1";
  } catch {
    return false;
  }
};

/* Store links: /site/{slug}/x on the platform host, /x on a connected custom domain. */
export const storePath = (slug, p = "") => `${isCustomHost() ? "" : `/site/${slug}`}${p || "/"}`;
